export const STATUSES = { blocked: "BLOCKED", active: "ACTIVE", pending: "PENDING" };
